import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IContentComponent } from 'src/app/interfaces/content-component.interface';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContentService } from 'src/app/services/content.service';
import { IdleService } from 'src/app/services/idle.service';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  providers: [AuthenticationService]
})
export class LoggedOutComponent implements OnInit, IContentComponent {

  private componentDestroyed = new Subject();

  pageComponentName: string = 'Logout';
  data!: Map<string, string>;

  constructor(
    private idleService: IdleService,
    private authenticationService: AuthenticationService,
    private contentService: ContentService) {

    this.idleService.stop();

    this.authenticationService.removeAuthValuesFromSessionStorage();

    this.contentService.content
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (data: Map<string, string>) => {
          if (data !== undefined) {
            this.data = data;
          }
        }
      );

    this.contentService.loadContent('pageText', this.pageComponentName, ['text', 'label']);
  }

  getLabelValue(label: string): string {
    let value: string = '';
    if (this.data) {
      value = this.data.get(label) ?? '';
    }
    return value;
  }

  ngOnInit(): void {
  }

}
